const synthetixv2 = require("./synthetix_v2");
const synthetixdualv2 = require("./synthetixdual_v2");

module.exports = {
  UNIV2_ROUTER_ADDRESS: "0xa5e0829caced8ffdd4de3c43696c57f7d7a678ff",
  FARMS: {
    synthetixv2,
    synthetixdualv2
  },
};
